<div class="row">
   <h4>{{sectionTitle  | translate}}</h4>
   <div class="db-list-com tz-db-table">
     <div class="item-view">
       <a [routerLink]="[templatesLink]">
         {{'VIEW_MORE' | translate}}
       </a>
     </div>
      <!------------ no published templates --------->
      <div class="tz-2-com tz-2-main" *ngIf="templates.length == 0">
        <div class="center no_data_message">
          <div class="icon-content"><i class="fas fa-cubes"></i></div>
          {{"NO_PUBLISEHD_TEMPLATE_MESSAGE" | translate}}
        </div>
      </div>
      <!------------ end no published templates --------->
      <!------------ published templates  exist --------->
        <!----------------------------  carousel  ------------------------------>
       <owl-carousel *ngIf="templates.length != 0" [options]="carouselOptions" [carouselClasses]="['owl-theme', 'row', 'sliding']">
         <app-listing-template-item *ngFor="let item of templates;let i= index" [data]="item" [homeSection]="'homeSection'">
         </app-listing-template-item>
        </owl-carousel>
        <!----------------------------  end carousel  ------------------------------>
      <!------------ end published templates exist--------->
   </div>
</div>
